import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=f597e036&scoped=true&"
import script from "./DonationForm.vue?vue&type=script&lang=js&"
export * from "./DonationForm.vue?vue&type=script&lang=js&"
import style0 from "./DonationForm.vue?vue&type=style&index=0&id=f597e036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f597e036",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtRadio: require('/home/bitrix/frontend/components/form/MtRadio.vue').default,Dropdown: require('/home/bitrix/frontend/components/form/Dropdown.vue').default,MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,MtSwitch: require('/home/bitrix/frontend/components/form/MtSwitch.vue').default,MtCheckbox: require('/home/bitrix/frontend/components/form/MtCheckbox.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,DonationModalFull: require('/home/bitrix/frontend/components/new-blocks/DonationModalFull.vue').default})
